import React from "react";


const SensorsLastValues = (props) => {
  const {selectedDev} = props

  //if (requestData?.sensors_card_data?.sensor_data?.length === 0) return null
  if (!selectedDev.requestData.sensors_card_data?.length ) return null

  const sensorsArray = selectedDev.requestData?.sensors_card_data

  //console.log(selectedDev.requestData.info)
  //console.log(sensorsArray)
 
  const lastValues = (sensor_data) => {
    const valuesArray = []
    sensor_data.map((o,k) => {
        valuesArray.push (
                o.card_prefix + o.last_value + o.card_suffix
            )
        })
    return <p className="card-text text-info">{valuesArray.join("; ")} </p>
  }
  

  return (
    <>
    {
        sensorsArray.map((v,i) => {
            return (
                <div className="border border-info rounded p-2 m-2" key={`sens_${i}`}>
                    <p className={`card-text ${v.min_ago < 10 ? 'text-success': 'text-secondary'}`}>
                        <strong>Sensor #</strong> {v.sensor_id} {`  ${v.min_ago < 10 ? '': 'over time'}`}
                    </p>
                    {lastValues(v.sensor_data)}
                    <p className="card-text text-muted">
                      
                      <strong>min ago:</strong> {`${v.min_ago}; `} <strong>date_created:</strong> {`${new Date(v.date_created).toLocaleString()}; `}
                      <strong>record_id:</strong> {`${v.record_id} `}
                    </p> 
                    
                </div>
/*                 <div className="container mt-5 border border-primary">
                    <p className="card-text">
                        <strong>Sensor #:</strong> {v.sensor_id}
                    </p>
                </div> */
            )
        })
    }
    </>
  )
}

export default SensorsLastValues

const DataTable = ({ data }) => {
  if (!data || data.length === 0) {
      return <p>No data available</p>;
  }

  return (
    <div className="container mt-5">
          <h2>Event Records</h2>
          <table className="table table-striped">
              <thead>
                  <tr>
                      <th>ID</th>
                      <th>Dev ID</th>
                      <th>Code</th>
                      <th>description</th>
                      <th>Data Created</th>
                  </tr>
              </thead>
              <tbody>
                  {data.map((item) => (
                      <tr key={item.id}>
                          <td>{item.id}</td>
                          <td>{item.dev_id}</td>
                          <td>{item.code}</td>
                          <td>{item.description}</td>
                          <td>{new Date(item.date_created).toLocaleString()}</td>
                      </tr>
                  ))}
              </tbody>
          </table>
      </div>
  );
};